import { convertFlagSiNo, getDescrizioneStatoIscrizione } from 'src/utilities/utility'
import { ClauseBuilder, GraphqlBuilder, GraphqlGroupBuilder } from 'src/utilities/graphqlUtilities'
import { getAnagrafeResourcesApi, getDefaultAxiosConfig } from 'src/app/utils/ManagerRestGateway'
import { TokenStore } from 'src/keycloak/jwt/TokenStore'
import { getCodificaStati } from 'src/processes/CodificaStati'
import { getOrdiniCompetentiList } from './ElencoIscrittiFilterQuery'
import { getDatiOrdineFederazioneByCodiceGruppo } from 'src/processes/Soggetto'

const normalizeNumber = (value: any): number => {
    if (Array.isArray(value)) {
        return Number(value[0])
    }
    return Number(value)
}


export async function elencoOperatoriList(codiceProvinciaResidenza, globalSearchParam, itemPageCount, listaStati, currentPage, filterParams, sortParam) {

    // Recupera la mappa degli stati con la relativa descrizione da utilizzare nei filtri.
    if (listaStati === undefined || listaStati === null || listaStati.length === 0) {
        var listaStati = [];
        await getCodificaStati().then(async (response) => {
            listaStati = response;
        })
    }

    // Rappresenta la lista degli ordini da filtrare (se CONAF non viene gestita nella WHERE)
    var ordiniCompetentiList = await getOrdiniCompetentiList();

    let index = normalizeNumber(currentPage);
    let limit = normalizeNumber(itemPageCount);

    if (Number.isNaN(index) || Number.isNaN(limit)) {
        throw new Error(`PagedRequestDto non valido: index=${index}, size=${limit}`)
    }

    var specificGroup = Object.keys(TokenStore?.getInstance()?.getCurrentAccount()?.accounts)[0]
    var genericGroup = TokenStore.getInstance().getCurrentAccount().accounts[specificGroup]?.genericGroup
    var tipologiaIscrizione
    var idFederazione

    //setto la tipologia iscrizione in base al genericGroup del currentAccount
    if (genericGroup === 'ODAF') {
        tipologiaIscrizione = 2
    }
    else if (genericGroup === 'CONAF') {
        tipologiaIscrizione = 4
    }

    else if (genericGroup === 'FODAF') {

        tipologiaIscrizione = 11

        await getDatiOrdineFederazioneByCodiceGruppo(specificGroup)
            .then((response) => {

                if (response?.data?.httpStatus !== 200)
                    throw new Error(response?.data?.error)

                const returned = response?.data?.returnedObject

                if (!Array.isArray(returned))
                    throw new Error('returnedObject non è un array')

                const federazione = returned.find(
                    f =>
                        f?.codiceGruppo === specificGroup ||
                        f?.codice === specificGroup
                )

                const rawId =
                    federazione?.id ??
                    federazione?.idFederazione

                if (rawId === undefined || rawId === null)
                    throw new Error(`idFederazione non presente per il gruppo ${specificGroup}`)

                idFederazione = Number(rawId)

                if (Number.isNaN(idFederazione))
                    throw new Error(`idFederazione non numerico per il gruppo ${specificGroup}`)
            })
            .catch((err) => {
                throw err
            })
    }

    // Valorizzo i parametri a partire dai filtri di ricerca
    if (filterParams === undefined || filterParams.length === 0)
        filterParams = [{ filterParamValue: "" }, { filterParamValue: "" }]
    const codiceFiscale = filterParams[0].filterParamValue
    const cognomeNome = filterParams[1].filterParamValue

    // Compongo la query query jpa in graph join
    const queryGraphContent = `{
        cf,
        codiceFiscaleAzienda,
        cognome,
        nome,
        tipoAnagrafe,
        pec,
        formaGiuridica,
        ragioneSociale,
        idIscrizione,
        ordineTerritorialeCompetente,
        statoIscrizione,
        tipologiaIscrizione,
        numeroIscrizioneOrdine,
        flagIscrizioneEpap,
        idFederazioneCompetente,
        cancellato
    }`;

    // Compongo la query di select, con gli eventuali order by
    const selectQuery = `{
        cf${sortField(sortParam?.codiceFiscale)},
        codiceFiscaleAzienda,
        cognome${sortField(sortParam?.cognomeNomeRagioneSociale)},
        nome${sortField(sortParam?.cognomeNomeRagioneSociale)},
        tipoAnagrafe${sortField(sortParam?.tipologia)},
        pec,
        idFederazioneCompetente,
        formaGiuridica,
        ragioneSociale${sortField(sortParam?.cognomeNomeRagioneSociale)},
        idIscrizione${sortField(sortParam?.nIscrizione)},
        ordineTerritorialeCompetente,
        tipologiaIscrizione,
        statoIscrizione${sortField(sortParam?.stato)},
        numeroIscrizioneOrdine,
        flagIscrizioneEpap,
        cancellato
    }`;

    var globalSearchQueryGraph = new GraphqlBuilder()
        .group(
            new GraphqlGroupBuilder()
                .in("tipologiaIscrizione", [tipologiaIscrizione])
                .in("ordineTerritorialeCompetente", (ordiniCompetentiList.length === 0 || genericGroup === "FODAF") ? null : ["\"" + ordiniCompetentiList.toString().replaceAll(",", "\",\"") + "\""])
                .in("idFederazioneCompetente", (genericGroup !== "FODAF") ? null : idFederazione)
                .or([new ClauseBuilder().in("cancellato", 0), new ClauseBuilder().isNull("cancellato", true)])
                .buildAND()
        )
        .group(
            new GraphqlGroupBuilder()
                .like("nome", globalSearchParam)
                .like("cognome", globalSearchParam)
                .like("cf", globalSearchParam)
                .buildOR()
        )
        .build();

    var filterSearchQueryGraph = new GraphqlBuilder()
        .group(
            new GraphqlGroupBuilder()
                .or([
                    new ClauseBuilder().like("nome", cognomeNome),
                    new ClauseBuilder().like("cognome", cognomeNome),
                ])
                .like("cf", codiceFiscale)
                .in("tipologiaIscrizione", [tipologiaIscrizione])
                .in("ordineTerritorialeCompetente", (ordiniCompetentiList.length === 0 || genericGroup === "FODAF") ? null : ["\"" + ordiniCompetentiList.toString().replaceAll(",", "\",\"") + "\""])
                .in("idFederazioneCompetente", (genericGroup !== "FODAF") ? null : idFederazione)
                .or([
                    new ClauseBuilder().in("cancellato", 0),
                    new ClauseBuilder().isNull("cancellato", true)
                ])
                .buildAND()
        )
        .build();

    var isFilterParamNotEmpty = filterParams.map(a => a.filterParamValue !== "").includes(true)

    var checkProfileFodaf
    var query

    //ODAF
    if (genericGroup !== "FODAF") {
        query = `{
            ordineTerritorialeCompetente: {${inClauseFromArray(ordiniCompetentiList?.toString().replaceAll(",", "\",\""))}},
            idFederazioneCompetente: { IS_NULL: true },
            tipologiaIscrizione: {IN: [${tipologiaIscrizione}]},
            OR:[
                {cancellato: {NE: 1}}, {cancellato:{IS_NULL: true}}
            ]    
        }`
    }

    //FODAF
    else {
        checkProfileFodaf = "IN: [" + idFederazione + "]"
        query = `{
            idFederazioneCompetente: { ${checkProfileFodaf} },
            tipologiaIscrizione: {IN: [${tipologiaIscrizione}]},
            AND:[
                {
                    OR:[
                        {cancellato: {NE: 1}}, {cancellato:{IS_NULL: true}},
                    ]  
                },
                {  
                    OR:[
                        {ordineTerritorialeCompetente: {EQ: ""}}, {ordineTerritorialeCompetente:{ IS_NULL: true } }
                    ]   
                }
            ]
        }`
    }

    let whereCondition = globalSearchParam !== "" && globalSearchParam !== undefined ?
        `${globalSearchQueryGraph}` :
        isFilterParamNotEmpty && filterParams !== undefined ?
            `${filterSearchQueryGraph}` :
            (ordiniCompetentiList.length === 0) ?
                `{
                tipologiaIscrizione: {IN: [${tipologiaIscrizione}]},
                OR:[
                    {cancellato: {EQ: 0}}, {cancellato:{IS_NULL: true}}
                ] 
            }`
                :
                `${query}`
        ;

    let jpaQuery = `{
        IscrittiEntityViews(
            page:{start: ${index}, limit: ${limit}}
            where: ${whereCondition}
        )
        {
            pages
            total
            select ${selectQuery}
        }
    }`;

    let queryGraph = `query allAnagrafeIscrizioniByFilter($pageRequest: PagedRequestDtoInput) {
        allAnagrafeIscrizioniByFilter(pageRequest: $pageRequest){
            index
            size
            totalCount
            pageCount
            content ${queryGraphContent}
        }
    }`;

    const json = {
        operationName: "allAnagrafeIscrizioniByFilter",
        query: queryGraph,
        variables: {
            "pageRequest": {
                "index": index,
                "size": limit,
                "jpsQuery": jpaQuery
            }
        }
    };

    var iscrizioneEpap
    var rows = await getAnagrafeResourcesApi()
        .msgaAnagrafeElencoIscrizioniPost(json.variables.pageRequest, getDefaultAxiosConfig())
        .then(response => {
            var descrizioneStatoIscrizione
            var rowsNames
            var responseData = response.data
            if (response?.data?.errors)
                throw new Error(response.data.errors[0].message)

            rowsNames = responseData.content.map((field) => (
                descrizioneStatoIscrizione = getDescrizioneStatoIscrizione(listaStati, field.statoIscrizione),
                iscrizioneEpap = convertFlagSiNo(field.flagIscrizioneEpap),
                {
                    data: [
                        field.cf,
                        field.cognome + " " + field.nome,
                    ]
                }))

            return {
                index: responseData.index,
                pageCount: responseData.pageCount,
                size: responseData.size,
                totalCount: responseData.totalCount,
                content: rowsNames
            }
        })
        .catch((err) => {
            throw new Error("Errore durante la get degli iscritti all'ordine " + err);
        })

    return JSON.stringify(rows)
}

function inClauseFromArray(arrayContent) {
    var array = "IN: [";
    array = array + "\"" + arrayContent + "\"" + "]";
    return array;
}

function sortField(sortDirection) {
    if (sortDirection)
        return "(orderBy: " + sortDirection?.toUpperCase() + ")"
    else
        return ""
}
